import { useEffect } from 'react';
import { isRouteErrorResponse, Link, useRouteError } from 'react-router';
import { useTranslation } from 'react-i18next';
import { EmptyState } from '@moods/ui';
import { reportError } from '../../lib/monitoring';
import { StatusLink } from './StatusLink';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <main className="error-page md-root">
      <EmptyState
        kind="not-found"
        title={t('errors.notFoundTitle')}
        description={t('errors.notFoundBody')}
        action={
          <Link className="md-btn md-btn--primary" to="/home">
            {t('actions.goHome')}
          </Link>
        }
      />
    </main>
  );
}

export function RouteErrorPage() {
  const { t } = useTranslation();
  const error = useRouteError();
  // a crash while rendering or loading a screen; 4xx route answers (404 …) are not errors of the app
  useEffect(() => {
    if (!(isRouteErrorResponse(error) && error.status < 500)) reportError(error);
  }, [error]);
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFoundPage />;
  if (import.meta.env.DEV) console.error(error);
  return (
    <main className="error-page md-root">
      <EmptyState
        kind="server-error"
        title={t('errors.serverTitle')}
        description={t('errors.serverBody')}
        action={
          <>
            <button type="button" className="md-btn md-btn--primary" onClick={() => location.reload()}>
              {t('actions.retry')}
            </button>
            <StatusLink />
          </>
        }
      />
    </main>
  );
}
